export enum LoadingStateVariant {
  INLINE = "inline",
  FULL_PAGE = "full-page",
}

export interface LoadingStateProps {
  isBoxed?: boolean;
  title?: string;
  subTitle?: string;
  buttonLabel?: string;
  variant?: LoadingStateVariant;
}

export interface LoadingStateEmits {
  (e: "buttonClick", event: MouseEvent): void;
}
